import { SurveysState } from './surveys';

export const surveysDefaultState: SurveysState = {
    programsSurveys: {},
};
